import { useEffect, useState } from "react";
import Master from '../../../../../assets/image 8.png'
import Visa from '../../../../../assets/visa.png'
import American from '../../../../../assets/image 22.png'
import Discover from '../../../../../assets/image 13 (1).png'
import { pricingData } from "../constant/data";




function PricingCard({ plan, isMiddle, isThird }) {
    return (
        // <div className={`relative bg-[#F7F6F4] rounded-lg shadow-lg ${isMiddle ? 'md:-mt-10' : ''} ${isThird ? 'md:-mt-6' : ''}`}>
        <div
            className={`relative bg-[#F7F6F4] rounded-lg shadow-lg 
            ${isMiddle ? 'order-1 md:order-none md:-mt-10' : ''}
            ${isThird ? 'order-2 md:order-none md:-mt-6' : ''}
            ${!isMiddle && !isThird ? 'order-3 md:order-none' : ''}
        `}
        >
            {/* Best Value Badge */}
            {plan.bestValue && (
                // <div className="absolute -top-2 -right-3 z-10 rotate-12">
                //     <div className="bg-red-600 text-white text-xs font-bold px-4 py-1 rounded-full shadow-md">
                //         BEST VALUE
                //     </div>
                // </div>
                <div className="relative">
                <div className="ribbon">
                    <p>
                        <span>BEST</span>
                        <span>VALUE</span>
                    </p>
                </div>
            </div>
            )}

            {/* Header */}
            <div className={`text-center rounded-t-lg p-4 ${plan.bestValue
                ? "bg-gradient-to-b from-[rgba(244,224,169,0)] via-[#eccc75] to-[#e7bf56]"
                : "bg-[#85ade1]"
                }`}>
                <h3 className="text-4xl font-bold text-[#132c4d]">{plan.title}<br />
                    {plan.subheading}</h3>

                <p className="text-xl font-semibold text-black">{plan.subtitle}</p>
                <p className="text-sm text-gray-600">{plan.bottleCount}</p>
            </div>

            {/* Content */}
            <div className={`p-6 space-y-6 ${plan.bestValue
                ? "bg-[#f0ddca]"
                : "bg-[#F7F6F4]"
                }`}>
                {/* Product Image */}
                <div className="w-60 h-60 mx-auto rounded-full bg-gray-200 ">
                    <img
                        src={plan.product}
                        alt="Product bottles"
                        className="w-full h-full object-cover"
                    />
                </div>

                {/* Pricing */}
                <div className="text-center space-y-4">
                    <div className="flex items-baseline justify-center gap-1">
                        <span className="text-5xl font-bold">${plan.pricePerBottle}</span>
                        <span className="text-gray-800 font-medium">/bottle</span>
                    </div>
                    {/* Features */}
                    <div className="space-y-2">
                        {plan.features.map((feature, idx) => (
                            <div
                                key={idx}
                                className={`py-2 px-4 rounded-md text-base  drop-shadow-md	 font-bold flex items-center justify-start gap-2 ${feature === "BIGGEST DISCOUNT"
                                    ? "bg-[#DE3C3E] text-white"
                                    : feature === "3 BONUSES"
                                        ? "bg-[#0A203C] text-white"
                                        : feature === "FAST & FREE SHIPPING"
                                            ? "bg-[#146e54] text-white"
                                            : "bg-[#0090E1] text-white"
                                    } text-shadow-md`}
                            >
                                <img src="https://sinoclear.net/pm/images/check-mark@2x.webp" className="h-6 w-6" />
                                {feature}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Order Button */}
                <div className="bg-[url('https://sinoclear.net/pm/images/CTA-new.png')] bg-no-repeat bg-center bg-contain h-24 flex items-center justify-center text-center text-xs">
                    <a
                        href="https://buygoods.com/secure/upsell/?account_id=10398&product_codename=spm3u&redirect=aHR0cHM6Ly9idXlnb29kcy5jb20vdGhhbmt5b3U%2FYWNjb3VudF9pZD0xMDM5OA%3D%3D&subid5=v2_10a8aace-0f8a-44a8-a764-4b0ebbd85e70_336c7c61-c4da-416a-9152-45384545a6b5_6765c427aed374ea40bacbb1_2237f13c-2dbf-4eaa-adf6-8b0180ada846_0_t-10"
                        className="-ml-5 font-bold pr-3 pb-1 text-xl "
                    >
                        ORDER NOW
                    </a>
                </div>
                {/* Payment Methods */}
                <div className="flex items-center justify-center gap-2 ">
                    {/* <div className="w-fit shadow-lg rounded-md bg-white
                ">
                        <img src={Payment} alt="payment cards" />
                    </div> */}
                    <div className='flex shadow-lg rounded-md bg-white p-2 items-center justify-center gap-2'>
                        <img src={Master} className='w-6' />
                        <img src={Visa} className='w-6' />
                        <img src={American} className='w-6' />
                        <img src={Discover} className='w-6' />

                    </div>
                </div>

                {/* Pricing */}
                <div className="flex items-center justify-around mx-16">
                    <div className="text-xl font-semibold">
                        Total:<span className="line-through text-gray-500 line-through-red">${plan.originalPrice}</span>
                    </div>
                    <div className="font-bold text-xl">${plan.discountedPrice}</div>
                </div>
            </div>

        </div>
    )
}

const PricingCards = ({ heading, startTimer }) => {

    const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds

    useEffect(() => {
        if (!startTimer) return;

        const timerInterval = setInterval(() => {
            setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(timerInterval); // Cleanup
    }, [startTimer]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    };

    return (
        <>
            <div className="flex items-center  bg-[#EBEBEB]  justify-center w-full flex-col gap-4 relative">
                {/* {startTimer && ( */}
                <div className="absolute -top-5 bg-[#fff9d3] py-2 px-5 border-[#efe7ae] rounded-3xl">
                    <h2 className="text-xl font-semibold text-black">
                        Your Order Is Reserved For <span className="text-red-500">{formatTime(timeLeft)}</span>
                    </h2>
                </div>
                {/* )} */}
                <div className=" p-3 bg-center bg-[url('https://sinoclear.net/pm/images/down-sec1.jpg')] bg-no-repeat h-52 w-full justify-center items-start pt-10 flex " >
                    <h3 className="text-4xl text-[#fdf651] font-bold  ">
                        {heading}
                    </h3>
                </div>
                <div className="container mx-auto px-4 py-8 max-w-6xl -mt-24">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {pricingData.map((plan, index) => (
                            <PricingCard key={index} plan={plan} isMiddle={index === 1} isThird={index === 2} />
                        ))}
                    </div>
                </div>

            </div>

        </>

    )
}

export default PricingCards



